import { render } from "./App.vue?vue&type=template&id=a9829d68"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"desktope/core/head/catalog-menu/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9829d68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9829d68', __exports__)) {
    api.reload('a9829d68', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=a9829d68", () => {
    api.rerender('a9829d68', render)
  })

}


export default __exports__